import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer
    className="container section"
    style={{
      textAlign: 'center',
      fontSize: '0.9rem',
      marginTop: '2rem',
      borderTop: '1px solid #ddd',
      paddingTop: '1rem',
      background: 'transparent',
    }}
  >
    <div>
      &copy; {new Date().getFullYear()} sparki<span style={{ fontSize: '0.7em', verticalAlign: 'super' }}>™</span>. All rights reserved.
    </div>
    <div style={{ marginTop: '0.75rem' }}>
      By using this site you agree to our{' '}
      <Link to="/terms-of-service" className="footer-link">Terms of Service</Link> and{' '}
      <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>.
    </div>
    <div style={{ marginTop: '0.35rem', fontSize: '0.8em' }}>
      <Link to="/support" className="footer-link">Support</Link>
      <span className="footer-link" style={{ margin: '0 0.35rem' }}>•</span>
      <Link to="/delete-account" className="footer-link">Delete Account</Link>
    </div>
  </footer>
);

export default Footer;
